module.exports = __webpack_public_path__ + "img/hsy.f99fc10c.png";